import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Table, Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { LOADING } from 'store';
import { api } from 'services';
import { CurrencyPlainText } from 'helpers/Currency';
import { parseDateBR } from 'helpers/date';
import collect from 'collect.js';

const EventsFormCompanies = ({ eventId }) => {
  const [show, setShow] = useState(false);
  const [companie, setCompanie] = useState([]);
  const [actions, setActions] = useState([]);
  const [vendorModal, setVendorModal] = useState([]);
  const [extraMaterialItems, setExtraMaterialItems] = useState([]);
  const [personalName, setPersonalName] = useState('');

  const vendorsArr = [];
  let eventActionsByVendors = [];
  let extraArr = [];

  const countInstallments = id => {
    let installment = 0;
    actions.map(action => {
      if (action.company_id === id) {
        installment++;
      }
    });
    return installment;
  };

  const totalFunds = id => {
    let countFund = 0;
    let countExtra = 0;
    actions.map(action => {
      action.all_values.map(fund => {
        if (action.company_id === id) {
          countFund += fund.actual_value * fund.exchange;
        }
      });
      if (action.extra_materials !== null && action.company_id === id) {
        action.extra_materials.map(extra => {
          countExtra += extra.value;
        });
      }
    });
    countFund = countFund + countExtra;
    countFund = countFund.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
    return countFund;
  };

  const createCompanies = () => {

    actions.forEach(action => {
      let c = {
        id: action.company_id,
        name: action.company.name,
        alias: action.company.alias,
        value: totalFunds(action.company_id),
        installments: countInstallments(action.company_id)
      };
      if (vendorsArr.length === 0) {
        vendorsArr.push(c);
      } else if (existVendor(action.company_id)) {
        vendorsArr.push(c);
      }
    });
  };

  const existVendor = id => {
    let flag = true;
    vendorsArr.forEach(company => {
      if (company.id === id) {
        flag = false;
      }
    });
    return flag;
  };

  const getActionsDetails = id => {
    eventActionsByVendors = [];

    actions.map(action => {
      let totalValue = 0;
      action.all_values.map(fund => {
        totalValue += fund.actual_value * fund.exchange;
      });
      let m = {
        id_company: action.company_id,
        action_name: action.name,
        date_payment: action.payment_date,
        value: totalValue,
        id_action: action.id
      };

      if (action.company.id === id) {
        eventActionsByVendors.push(m);
      }
    });
    setVendorModal(eventActionsByVendors);
  };

  const getExtraMaterials = id => {
    let extraMaterial;
    extraArr = [];
    actions.map(action => {
      action.extra_materials.map(extra => {
        if (action.company.id === id) {
          extraMaterial = {
            extra_id: extra.id,
            id_action: extra.action_id,
            name: extra.name,
            value: extra.value
          };
          extraArr.push(extraMaterial);
        }
      });
    });
    setExtraMaterialItems(extraArr);
  };

  const personalizedName = id => {
    let personalizedName;
    companie.map(company => {
      if (company.id === id) {
        personalizedName = `${t('title:sponsorship')} - ${company.alias}`;
      }
    });
    setPersonalName(personalizedName);
  };

  const handleListEventQuotes = id => {
    setShow(true);
    eventActionsByVendors = getActionsDetails(id);
    getExtraMaterials(id);
    personalizedName(id);
  };

  const exitModal = () => {
    setShow(false);
  };

  const { t } = useTranslation();

  useEffect(() => {
    api.get('companies/all').then(({ data }) => setCompanie(data));
  }, []);

  useEffect(() => {
    api.get(`event-actions/${eventId}`).then(({ data }) => setActions(data));
  }, []);

  return (
    <>
      {/*---------- TABLE DE VENDORS NA VIEW DE EDIT ---------- */}

      <Row>
        <Col>
          <h4>{t('title:company')}</h4>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th className="text-center align-middle">
                  {t('label:company name')}
                </th>
                <th className="text-center align-middle">
                  {t('label:quota value')}
                </th>
                <th className="text-center align-middle">
                  {t('label:installments')}
                </th>
                <th className="text-center align-middle">
                  {t('label:actions')}
                </th>
              </tr>
            </thead>
            <tbody>
              {createCompanies()}
              {collect(vendorsArr).sortBy('alias').map((vendor, k) => (
                <tr key={k}>
                  <td className="text-center align-middle">{vendor.name}</td>
                  <td className="text-center align-middle">
                    {' '}
                    <CurrencyPlainText value={vendor.value} />
                  </td>
                  <td className="text-center align-middle">
                    {vendor.installments}
                  </td>
                  <td className="text-center align-middle">
                    <Button
                      variant="light"
                      size="sm"
                      onClick={() => handleListEventQuotes(vendor.id)}
                    >
                      <i className="fas fa-list-ul"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>

      {/*---------- MODAL DE ACOES DE EVENTOS NA VIEW DE EDIT ---------- */}

      <Modal
        size="lg"
        dialogClassName="modal-80w"
        show={show}
        onHide={exitModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>{personalName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th className="text-center align-middle">
                  {t('label:action name')}
                </th>
                <th className="text-center align-middle">
                  {t('label:payment date')}
                </th>
                <th className="text-center align-middle">
                  {t('label:quota value')}
                </th>
                <th className="text-center align-middle">
                  {t('label:action link')}
                </th>
              </tr>
            </thead>
            <tbody>
              {vendorModal.map(action => (
                <tr key={action.id_action}>
                  <td className="text-center align-middle">
                    {action.action_name}
                  </td>
                  <td className="text-center align-middle">
                    {parseDateBR(action.date_payment)}
                  </td>
                  <td className="text-center align-middle">
                    <CurrencyPlainText value={action.value} />
                  </td>
                  <td className="text-center align-middle">
                    <Link
                      className="ml-2"
                      variant="light"
                      target="_blank"
                      style={{ fontSize: 12 }}
                      to={`/actions/edit/${action.id_action}`}
                    >
                      <i className="fas fa-external-link-alt" />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <h5 className="mt-3 mb-3">{t('title:extra action')}</h5>
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th className="text-center align-middle">
                  {t('label:name')}
                </th>
                <th className="text-center align-middle">{t('label:value')}</th>
                <th className="text-center align-middle">
                  {t('label:action link')}
                </th>
              </tr>
            </thead>
            <tbody>
              {extraMaterialItems.map(item => (
                <tr key={item.extra_id}>
                  <td className="text-center align-middle">{item.name}</td>
                  <td className="text-center align-middle">
                    <CurrencyPlainText value={item.value} />
                  </td>
                  <td className="text-center align-middle">
                    <Link
                      className="ml-2"
                      variant="light"
                      style={{ fontSize: 12 }}
                      target="_blank"
                      to={`/actions/edit/${item.id_action}`}
                    >
                      <i className="fas fa-external-link-alt" />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    </>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  loading: payload => dispatch({ type: LOADING, payload })
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsFormCompanies);
